<section id="kontakt" class="pure-contact" #contactSection>
  <div class="container">
    
    <!-- TITLE -->
    <div class="section-title">
      <h2>Kontakt</h2>
    </div>

    <!-- CONTENT -->
    <div class="content-wrapper">
      
      <!-- INFO STACK -->
      <div class="info-stack">
        <div class="info-line">
          <span class="icon">📍</span>
          <span class="details">
            <span class="label">Adresa</span>
            <span>Moševac bb, 74250 Maglaj, BiH</span>
          </span>
        </div>

        <div class="info-line">
          <span class="icon">📞</span>
          <span class="details">
            <span class="label">Rezervacije</span>
            <a href="tel:+38762129666">+387 62 129 666</a>
          </span>
        </div>

        <div class="info-line">
          <span class="icon">🕐</span>
          <span class="details">
            <span class="label">Radno vrijeme</span>
            <span>Pon-Ned 07:00-23:00h</span>
          </span>
        </div>
      </div>

      <!-- MAPA -->
      <div class="map-container">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1135.8!2d18.089595!3d44.5937728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475e910060d285d7%3A0xea8fc471cdf88b69!2sRestoran%20Kockica!5e0!3m2!1shr!2sba!4v1737000000000!5m2!1shr!2sba"
          width="100%" height="100%" style="border:0;" allowfullscreen="" 
          loading="lazy" referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>

    </div>

  </div>
</section>
